module.exports = __webpack_public_path__ + "static/media/amphoe.19790818.svg";